<div class="container-fluids">
    <div class="row">
        <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
                <h4 class="mb-0 font-size-18">NOTIFICATION</h4>
                <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                    </ol>
                </div>
                <img src="assets/newImages/cross2.png" alt="" 
      (click)="activeModal.dismiss()">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card_2 mb-5">
                <div class="card-body">

                    <div class="row ">

                        <div class=" col-lg-12">
                            <!-- <table>
                                <tr>
                                    <th>Notification</th>

                                </tr>
                                <tr *ngFor="let a of allNotification">
                                    <td colspan="10">{{ a.message }}</td>
                                    <td colspan="2" style="text-align: end;">{{ a.created_date }}</td>
                                </tr>


                            </table> -->
                            <table class="notification-table">
                                <!-- <tr>
                                    <th colspan="2">Notification</th>
                                </tr> -->
                                <!-- <tr *ngFor="let a of allNotification" [class.unread]="a.is_read === 0">
                                    <td class="message">{{ a.message }}</td>
                                    <td class="date">{{ a.created_date }}</td>
                                </tr> -->
                                <tr *ngFor="let a of allNotification" [class.unread]="a.is_read === 0"
                                    (click)="handleNotificationClick(a)" style="cursor: pointer;">
                                    <td class="message">{{ a.message }}</td>
                                    <td class="date">{{ a.created_date }}</td>
                                </tr>

                            </table>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>